<template lang="pug">
  .ok-cancel-modal
    b-modal(v-model="_value" :size="size" hide-header @ok="ok" @cancel="cancel")
      .default-modal-body
        .default-modal-title {{ title }}
        .default-modal-message(v-if="message").mt-2 {{ message }}

      template(#modal-footer="{ ok, cancel }")
        b-button.btn.modal-ok-btn(@click="ok") OK
        b-button.btn.modal-cancel-btn(@click="cancel") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### OK/キャンセルモーダル
 */
@Component
export default class OkCancelModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** タイトル */
  @Prop({ required: true })
  title!: string;
  /** メッセージ */
  @Prop()
  message!: string;
  /** モーダルサイズ */
  @Prop({ default: () => "md" })
  size!: string;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }

  public cancel(): void {
    this.$emit("cancel");
    return;
  }
}
</script>
